/**
 * reportReferral v0.1 (cc_tasks row 321, T355): a buyer's personal invite link carries ?rr=<token>.
 * The static pages keep it in this browser (localStorage mf_rr, order-report.js v2.2 / ad-landing.js
 * v1.3); this does the same in the app and, once somebody is signed in, links the token to their
 * account once (run-service report_feedback claim_ref). Then their first paid plan, credit pack or
 * report credits them and whoever invited them (public.report_referral_reward). Sends nothing.
 */
import { supabase } from "@/integrations/supabase/client";

const KEY = "mf_rr";
const FN = "https://wnzxffwiiubqvcvnnjbz.supabase.co/functions/v1/run-service/report_feedback";
type Held = { rr: string; at: number; claimed?: boolean };

function read(): Held | null {
  try {
    const o = JSON.parse(localStorage.getItem(KEY) || "null");
    return o && /^[0-9a-f]{18}$/.test(o.rr) && Date.now() - o.at < 30 * 864e5 ? o : null;
  } catch { return null; }
}

async function claim(accessToken: string) {
  const o = read();
  if (!o || o.claimed) return;
  try {
    const r = await fetch(FN, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ action: "claim_ref", rr: o.rr }),
    });
    const j = await r.json().catch(() => null);
    if (j?.ok) localStorage.setItem(KEY, JSON.stringify({ ...o, claimed: true }));
  } catch { /* tried again on the next sign-in */ }
}

export function initReportReferral(): void {
  if (typeof window === "undefined") return;
  try {
    const m = /[?&]rr=([0-9a-f]{18})(?:&|$)/.exec(window.location.search);
    if (m) localStorage.setItem(KEY, JSON.stringify({ rr: m[1], at: Date.now() }));
  } catch { /* storage off */ }
  if (!read()) return;
  supabase.auth.getSession().then(({ data }) => { if (data?.session?.access_token) void claim(data.session.access_token); }).catch(() => {});
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === "SIGNED_IN" && session?.access_token) void claim(session.access_token);
  });
}
